import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NavigationService } from '../../shared/services/navigation.service';
import { HotspotAlertService } from '../shared/hotspot-alert.service';
import { HotspotAlertSearchCriteria } from '../shared/hotspot-alert-search-criteria.model';
import { DataTableColumn } from '../../shared/data-table/data-table.component';
import { SortDirection } from '../../shared/sort-direction';
import { Option } from '../../shared/data-filters/data-filter-select/data-filter-select.component';
import * as moment from 'moment';
import { HotspotType } from '../shared/hotspot-type.model';
import { ActivatedRoute, Router } from '@angular/router';
import { RegionService } from 'app/user-dashboard/shared/region.service';
import { NavigationLinkService } from '../../shared/services/navigation-link.service';
import {AuthenticationService} from '../../shared/services/authentication.service';

@Component({
  selector: 'app-hotspots-alerts',
  templateUrl: './hotspots-alerts.component.html',
  styleUrls: ['./hotspots-alerts.component.scss']
})
export class HotspotsAlertsComponent implements OnInit {

  hotspotsTypesOptions: Option[] = [
    { labelKey: 'hotspots.alerts.filters.hotspot-type.placeholder', value: undefined },
    { labelKey: 'hotspots.types.recycler', value: HotspotType.RECYCLER },
    { labelKey: 'hotspots.types.service-center', value: HotspotType.SERVICE_CENTER },
    { labelKey: 'hotspots.types.customer', value: HotspotType.CUSTOMER }
  ];

  filters: HotspotAlertSearchCriteria = {};

  startDate: moment.Moment;
  endDate: moment.Moment;
  filtersMaxDate = moment();
  regions: Option[] = [{ labelKey: 'hotspots.alerts.filters.region.placeholder', value: undefined }];

  @ViewChild('userIdColumn', { static : true })
  userIdColumn: TemplateRef<any>;

  @ViewChild('regionColumn', { static : true })
  regionColumn: TemplateRef<any>;

  @ViewChild('loadsIdsColumn', { static : true })
  loadsIdsColumn: TemplateRef<any>;

  @ViewChild('loadsNumbersColumn', { static : true })
  loadsNumbersColumn: TemplateRef<any>;

  @ViewChild('vehicleIdColumn', { static : true })
  vehicleIdColumn: TemplateRef<any>;

  @ViewChild('hotspotColumn', { static : true })
  hotspotColumn: TemplateRef<any>;

  @ViewChild('enteredAtColumn', { static : true })
  enteredAtColumn: TemplateRef<any>;

  @ViewChild('leftAtColumn', { static : true })
  leftAtColumn: TemplateRef<any>;

  @ViewChild('recordedAtColumn', { static : true })
  recordedAtColumn: TemplateRef<any>;

  columns: DataTableColumn[] = [];
  sortColumn: DataTableColumn;
  public canAccessRegionManagementScreen = false;

  loadPage = (page: number, pageSize: number, sortColumn: DataTableColumn, direction: SortDirection) =>
    this.alertService.search(page - 1, pageSize, sortColumn.name, direction, this.filters);

  constructor(
    private route: ActivatedRoute,
    private alertService: HotspotAlertService,
    private navigation: NavigationService,
    public link: NavigationLinkService,
    private router: Router,
    private regionService: RegionService,
    private authenticationService: AuthenticationService
  ) {
  }

  ngOnInit() {
    const recordedAtColumn = {
      name: 'recorded_at',
      displayed: true,
      translationKey: 'hotspots.alerts.table.recorded-at',
      template: this.recordedAtColumn,
      sortable: true
    };

    this.columns = [
      {
        name: 'user_id',
        displayed: true,
        translationKey: 'hotspots.alerts.table.user-id',
        template: this.userIdColumn,
        sortable: true
      },
      {
        name: 'region',
        displayed: true,
        translationKey: 'hotspots.alerts.table.region',
        template: this.regionColumn,
        sortable: true
      },
      {
        name: 'loads_ids',
        displayed: true,
        translationKey: 'hotspots.alerts.table.loads-ids',
        template: this.loadsIdsColumn,
        sortable: false
      },
      {
        name: 'loads_numbers',
        displayed: true,
        translationKey: 'hotspots.alerts.table.loads-numbers',
        template: this.loadsNumbersColumn,
        sortable: false
      },
      {
        name: 'vehicle_id',
        displayed: true,
        translationKey: 'hotspots.alerts.table.vehicle-id',
        template: this.vehicleIdColumn,
        sortable: true
      },
      {
        name: 'hotspot_id',
        displayed: true,
        translationKey: 'hotspots.alerts.table.hotspot',
        template: this.hotspotColumn,
        sortable: true
      },
      {
        name: 'entered_at',
        displayed: true,
        translationKey: 'hotspots.alerts.table.entered-at',
        template: this.enteredAtColumn,
        sortable: true
      },
      {
        name: 'left_at',
        displayed: true,
        translationKey: 'hotspots.alerts.table.left-at',
        template: this.leftAtColumn,
        sortable: true
      },
      recordedAtColumn
    ];

    this.sortColumn = recordedAtColumn;
    this.route.queryParams.subscribe(params => {
      this.filters.user_id       = params.user_id;
      this.filters.region_id     = params.region_id;
      this.filters.load_id       = params.load_id;
      this.filters.load_number   = params.load_number;
      this.filters.vehicle_id    = params.vehicle_id;
      this.filters.hotspot_label = params.hotspot_label;
      this.filters.hotspot_type  = params.hotspot_type;
      this.filters.start_date    = params.start_date ? moment(+params.start_date).format('YYYY-MM-DD') : null;
      this.filters.end_date      = params.end_date ? moment(+params.end_date).format('YYYY-MM-DD') : null;
      this.filters.alert_id      = params.alert_id;
      if (this.filters.start_date && this.filters.start_date !== 'Invalid date') {
        this.startDate = moment(this.filters.start_date);
      }
      if (this.filters.end_date && this.filters.end_date !== 'Invalid date') {
        this.endDate = moment(this.filters.end_date);
      }
    });

    this.regionService.getAllLight().subscribe(regions => {
      regions.map(region => this.regions.push({ labelKey: region.name, value: region.id }));
    });

    this.canAccessRegionManagementScreen = this.authenticationService.canManageRegions();
  }

  updateDateFilters() {
    if (this.startDate) {
      this.filters.start_date = this.startDate.valueOf();
    } else {
      this.filters.start_date = null;
    }

    if (this.endDate) {
      this.filters.end_date = this.endDate.valueOf();
    } else {
      this.filters.end_date = null;
    }
  }

  resetFilters() {
    this.startDate = null;
    this.endDate   = null;
  }

  goToHotspot(hotspotId: string) {
    this.navigation.hotspots()
      .map(hotspotId)
      .go();
  }

  pageLoaded() {
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: this.filters
      }
    );
  }
}
